<template>
	<div class="container">
		<div class="content">
			<div class="card mb_0">
				<h3 id="selectAsset" class="title mb_20">
					{{ $t('rtr_pay-payment.title1') }}
				</h3>
				<div class="mb_20">
					<AccountPicker @changeAccount="getAccountInfo"></AccountPicker>

					<div v-if="isSelectedAccount" class="bg_black_box">
						<div class="d_flex justify_between">
							<div class="asset_box">
								<span
									:class="[selectedAccountInfo?.asset_code, 'medium']"
								></span>
								<div>
									<p class="code mb_4">{{ selectedAccountInfo?.asset_code }}</p>
									<p class="name">{{ selectedAccountInfo?.asset_title }}</p>
								</div>
							</div>

							<div class="balance_area">
								<div class="quantity mr_5 fc_white">
									{{ selectedAccountInfo?.balance }}
								</div>
								<span class="currency fc_white">{{
									selectedAccountInfo?.asset_code
								}}</span>
							</div>
						</div>
					</div>
				</div>
				<h3
					id="selectWay"
					class="title mb_20"
					v-if="!selectedAccountInfo || selectedAccountInfo?.code !== 'JPYS'"
				>
					{{ $t('rtr_pay-payment.title2') }}
				</h3>
				<div class="mb_20">
					<ul class="d_flex withdraw mb_20 tac">
						<li
							class="w50"
							v-if="
								!selectedAccountInfo || selectedAccountInfo?.code !== 'JPYS'
							"
						>
							<input
								type="radio"
								id="way1"
								class="radio_way"
								v-model="selectedWay"
								name="selectWay"
								value="way1"
								@click="selectWay"
							/>
							<label for="way1" class="w100 type_01">
								<span class="coin_name">
									{{ $t('rtr_pay-payment.text1') }}
								</span>
							</label>
						</li>
						<li
							class="w50"
							v-if="
								!selectedAccountInfo || selectedAccountInfo?.code !== 'JPYS'
							"
						>
							<input
								type="radio"
								id="way2"
								class="radio_way"
								v-model="selectedWay"
								name="selectWay"
								value="way2"
								@click="selectWay"
							/>
							<label for="way2" class="w100 type_01">
								<span class="coin_name">
									{{ $t('rtr_pay-payment.text2') }}
								</span>
							</label>
						</li>
					</ul>

					<div class="">
						<div v-show="this.showTab === 'way1'">
							<div class="mb_20">
								<p class="mb_10">{{ $t('rtr_pay-payment.text4') }}</p>
								<div class="search_area mb_8">
									<input
										type="text"
										:placeholder="$t('rtr_pay-payment.text5')"
										v-model="toAccountNumber"
										@keydown.enter="findAccountInfo"
										@change="findAccountInfo"
									/>
									<a class="search_icon SEARCH" @click="findAccountInfo"></a>
								</div>
								<span
									class="caution"
									v-if="toAccountNumber && isCheckAccount && !toAccountInfo"
									>{{ $t('rtr_pay-payment.caution') }}</span
								>
							</div>
							<div
								class="mb_20"
								v-if="toAccountNumber && isCheckAccount && toAccountInfo"
							>
								<p class="mb_10">{{ $t('rtr_pay-payment.recipient') }}</p>
								<input type="text" :value="toAccountInfo.user_name" disabled />
							</div>
							<div>
								<p class="mb_10">{{ selectedAccountInfo?.asset_code }}</p>
								<input type="text" placeholder="0" v-model="sendAmount" />
							</div>
						</div>

						<div v-show="this.showTab === 'way2'">
							<div class="mb_20">
								<p class="mb_10">{{ $t('rtr_pay-payment.text6') }}</p>
								<div class="search_area">
									<input
										type="text"
										:placeholder="$t('rtr_pay-payment.text7')"
										v-model="toAccountAddress"
									/>
									<a class="search_icon SEARCH"></a>
								</div>
							</div>
							<div>
								<p class="mb_10">{{ $t('rtr_pay-payment.text8') }}</p>
								<input type="text" placeholder="0" v-model="sendAmount" />
							</div>
						</div>
					</div>
				</div>
				<div class="button_area">
					<button @click="toDashboard">
						{{ $t('button.cancel') }}
					</button>
					<button
						class="button_bg_red"
						@click="isTransferCheck = true"
						:disabled="!canSend"
					>
						{{ $t('button.send') }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<ModalView v-if="isTransferCheck" @closeModal="isTransferCheck = false">
		<div v-if="selectedWay === 'way1'">
			<p class="account_name">{{ toAccountInfo?.user_name }}</p>
			<p class="account_number">{{ toAccountInfo?.account_number }}</p>
			<p class="amount">
				{{ sendAmount }} <span>{{ selectedAccountInfo?.asset_code }}</span>
			</p>
			<p class="text">{{ $t('rtr_pay-payment.askWithdraw') }}</p>
		</div>
		<div v-if="selectedWay === 'way2'">
			<p class="account_name">
				{{ $t('rtr_pay-payment.modal.wallet_account') }}
			</p>
			<!--			<p class="account_name">{{ toAccountInfo?.user_name }}</p>-->
			<p class="account_number">{{ toAccountAddress }}</p>
			<p class="amount">
				{{ sendAmount }} <span>{{ selectedAccountInfo?.asset_code }}</span>
			</p>
			<p class="text">{{ $t('rtr_pay-payment.askWithdraw') }}</p>
		</div>
		<div class="button_area">
			<button class="fc_blue" @click="isTransferCheck = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="accountTransferHandler">
				{{ $t('button.withdraw') }}
			</button>
		</div>
	</ModalView>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div class="button_area" v-if="messageModalType === 'error'">
			<button class="fc_red oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div class="button_area" v-if="messageModalType === 'success'">
			<button class="fc_red" @click="toDashboard">
				{{ $t('button.close') }}
			</button>
			<button class="fc_blue" @click="toActivity">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessage>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import ModalView from '@/components/Layout/ModalView';
import AccountPicker from '@/components/AccountPicker.vue';
import ModalMessage from '@/components/Layout/ModalMessage';
import Tutorial from '@/components/Tutorial';
import Cookies from 'js-cookie';
import { mapGetters } from 'vuex';
import { Navigation } from 'swiper';
import { createAccountTransfer, fetchAccount } from '@/api/account';
import { commonError } from '@/common/dialog';
import { createWithdraw } from '@/api/withdraw';
import {
	createWithdrawAddress,
	deleteWithdrawAddress,
	fetchWithdrawAddressList,
} from '@/api/kyc';

export default {
	name: 'Payment.vue',
	components: {
		ModalView,
		ModalMessage,
		AccountPicker,
		Tutorial,
		// Cookies,
	},
	props: {
		seq: {
			type: Number,
		},
	},
	data() {
		return {
			modules: [Navigation],
			showTab: null,
			selected: false,
			selectedAccountSeq: 0,
			selectedWay: '',
			isTransferCheck: false,
			isSelectedAccount: false,
			modalAddStep: 0,
			checked: false,
			messageModal: false,
			modalIcon: 'error',
			modalStatusMessage: '',
			messageModalType: '',
			toAccountNumber: '',
			toAccountInfo: null,
			toAddressInfo: null,
			sendAmount: null,
			toAccountAddress: '',
			isCheckAccount: false,
			isCheckAddress: false,
			withdrawAddressList: [],
			tour: null,
			showTutorial: false,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('account', ['own_assets_group']),
		...mapGetters('assets', ['assets']),
		...mapGetters('auth', ['member_info']),
		...mapGetters('lang', ['lang']),

		own_assets_items() {
			let data = [];
			const group = Object.keys(this.own_assets_group).map(Number);
			this.assets.forEach(asset_item => {
				if (group.includes(asset_item.seq)) data.push(asset_item);
			});
			return data;
		},
		selectedAccountInfo() {
			return this.accounts.find(account => {
				return account.seq === parseInt(this.selectedAccountSeq);
			});
		},
		canSend() {
			if (this.selectedWay === 'way1') {
				return (
					this.selectedAccountInfo && this.toAccountInfo && this.sendAmount
				);
			} else if (this.selectedWay === 'way2') {
				return this.selectedAccountInfo && this.sendAmount;
			} else {
				return false;
			}
		},
	},
	watch: {
		selectedAccountInfo() {
			this.selectedWay = 'way1';
			this.showTab = 'way1';
		},
		toAccountNumber() {
			this.isCheckAccount = false;
		},
		toAccountAddress() {
			this.isCheckAddress = false;
		},
	},
	created() {
		if (this.$route.query.accountSeq) {
			this.selectedAccountSeq = this.$route.query.accountSeq;
			this.isSelectedAccount = true;
		}
		this.init();
	},
	methods: {
		init() {
			this.loadWithdrawAddressList();
		},
		initData() {
			this.selectedWay = null;
			this.showTab = '';
			this.showQrReader = false;
			this.initQrReader = false;
			this.toAccountNumber = '';
			this.toWalletAddress = '';
			this.sendAmount = null;
		},
		async loadWithdrawAddressList() {
			const params = {
				no_paging: 1,
				is_valid: 'Y',
			};
			const { data } = await fetchWithdrawAddressList(params).catch(
				commonError,
			);
			this.withdrawAddressList = data;
		},
		selectWay(e) {
			if (!this.selectedAccountInfo?.seq) {
				e.target.checked = false;
				this.modalStatusMessage = this.$t('modal.message.select_asset');
				this.messageModalType = 'error';
				this.messageModal = true;
				return;
			}
			this.showTab = e.target.id;
		},
		checkAsset(e) {
			let selected = e.target.value;
			console.log('selected : ', selected);
		},
		getAccountInfo(accountSeq) {
			this.selectedAccountSeq = accountSeq;
			this.isSelectedAccount = true;
		},
		stepBack() {
			this.modalAddStep--;
		},
		stepNext() {
			this.modalAddStep++;
		},
		toDashboard() {
			this.$router.push({ name: 'auth-dashboard' });
		},
		toActivity() {
			this.$router.push({
				name: 'activity',
				query: { account_seq: this.selectedAccountSeq },
			});
		},
		findAccountInfo() {
			fetchAccount({
				account_seq_or_number: this.toAccountNumber,
				for_transfer: 1,
			})
				.then(result => {
					this.toAccountInfo = result.account_info;
				})
				.catch(commonError)
				.finally(() => {
					this.isCheckAccount = true;
				});
		},
		accountTransferHandler() {
			if (!this.validations()) {
				this.modalIcon = 'success';
				this.messageModalType = 'error';
				this.messageModal = true;
				return;
			}
			switch (this.selectedWay) {
				case 'way1':
					this.accountTransfer();
					break;
				case 'way2':
					this.accountTransferBlock();
					break;
			}
		},
		async accountTransfer() {
			// if (!this.validations()) {
			// 	this.messageModalType = 'error';
			// 	this.messageModal = true;
			// 	return;
			// }
			const params = {
				from_seq: this.selectedAccountSeq,
				to_seq: this.toAccountInfo.seq,
				amount: this.sendAmount,
			};
			await createAccountTransfer(params)
				.then(() => {
					this.$store.dispatch('account/getAccounts');
					this.isTransferCheck = false;
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_withdraw');
					this.messageModalType = 'success';
					this.messageModal = true;
					this.initData();
				})
				.catch(commonError);
		},
		async accountTransferBlock() {
			const withdrawAddressInfo = this.withdrawAddressList.find(item => {
				return item.asset_seq === this.selectedAccountInfo.asset_seq;
			});
			let params = {};
			if (withdrawAddressInfo) {
				await deleteWithdrawAddress(withdrawAddressInfo.seq)
					.then(() => {
						this.loadWithdrawAddressList();
						params = {
							asset_seq: this.selectedAccountInfo.asset_seq,
							address: this.toAccountAddress,
						};
						createWithdrawAddress(params)
							.then(() => {
								this.loadWithdrawAddressList();
								params = {
									account_seq: this.selectedAccountSeq,
									request_amount: this.sendAmount,
								};
								createWithdraw(params)
									.then(() => {
										this.$store.dispatch('account/getAccounts');
										this.isTransferCheck = false;
										this.modalIcon = 'success';
										this.modalStatusMessage = this.$t(
											'modal.message.success_withdraw',
										);
										this.messageModalType = 'success';
										this.messageModal = true;
										this.initData();
									})
									.catch(commonError);
							})
							.catch(commonError);
					})
					.catch(commonError);
			} else {
				params = {
					asset_seq: this.selectedAccountInfo.asset_seq,
					address: this.toAccountAddress,
				};
				createWithdrawAddress(params)
					.then(() => {
						this.loadWithdrawAddressList();
						params = {
							account_seq: this.selectedAccountSeq,
							request_amount: this.sendAmount,
						};
						createWithdraw(params)
							.then(() => {
								this.$store.dispatch('account/getAccounts');
								this.isTransferCheck = false;
								this.modalIcon = 'success';
								this.modalStatusMessage = this.$t(
									'modal.message.success_withdraw',
								);
								this.messageModalType = 'success';
								this.messageModal = true;
								this.initData();
							})
							.catch(commonError);
					})
					.catch(commonError);
			}
		},
		validations() {
			if (!this.selectedAccountInfo) {
				this.modalStatusMessage = this.$t('modal.message.select_asset');
				return false;
			}
			if (!this.selectedWay) {
				this.modalStatusMessage = this.$t('modal.message.select_way');
				return false;
			}
			if (this.selectedWay === 'way1') {
				if (!this.toAccountInfo) {
					this.modalStatusMessage = this.$t('modal.message.check_account');
					return false;
				}
			} else if (this.selectedWay === 'way2') {
				if (!this.toAccountAddress) {
					this.modalStatusMessage = this.$t('modal.message.check_address');
					return false;
				}
			}
			if (!this.sendAmount) {
				this.modalStatusMessage = this.$t('modal.message.set_amount');
				return false;
			}
			return true;
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
	},
	mounted() {
		this.tutorialHandler();
	},
};
</script>

<style scoped></style>
